import { REPORT_TYPES_SLOT } from './relatorios'

export default [
  {
    key: 'dashboard',
    icon: 'mdi-view-dashboard',
    title: 'Dashboard',
    to: '/central/dashboard',
  },
  {
    key: 'fazendas',
    icon: 'mdi-home-flood',
    title: 'Fazendas',
    to: '/central/fazendas',
  },
  {
    key: 'agenda',
    icon: 'mdi-calendar-month',
    title: 'Agenda',
    to: '/central/schedules',
  },
  {
    key: 'relatorios-grupo',
    icon: 'mdi-clipboard-list',
    title: 'Relatórios',
    group: '/central/relatorios',
    children: [REPORT_TYPES_SLOT],
  },
]
